import { LocalizeNameSpaceTypes, useLocale } from '@gov-nx/core/service';
import type { FormCheckboxProps } from '@gov-nx/ui/types';

/**
 * Hook that provides the __souhlas checkbox field configuration for forms
 * that don't use FormBuilder. Always returns field props — use `show` prop
 * on SouhlasCheckbox to control visibility.
 */
export const useAuthorizationConsentField = (
	isDisabled = false
): FormCheckboxProps => {
	const { t } = useLocale(LocalizeNameSpaceTypes.Form);

	return {
		field: {
			name: '__souhlas',
			size: 'm',
			isDisabled,
			label: { children: t('form.field.souhlas') },
		},
	};
};
